import { NavLink } from 'react-router-dom';

/**
 * Le impostazioni sono due mondi diversi: quelle dell'app (navigatore, rubrica)
 * si toccano da casa, quelle della livella si toccano una volta sola e poi mai
 * più. Stanno su due indirizzi distinti invece che una pagina sola lunghissima,
 * ma sotto un'unica voce di menu: la barra in alto ha già cinque voci e va a capo.
 */
export function SettingsTabs() {
  return (
    <nav className="settings-tabs" aria-label="Sezioni delle impostazioni">
      {/* end: senza, "App" resterebbe attiva anche sulla scheda Livella. */}
      <NavLink to="/settings" end>
        ⚙️ App
      </NavLink>
      <NavLink to="/settings/livella">📐 Livella</NavLink>
    </nav>
  );
}
